import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageSERIEA5 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Roma Edges Inter 1-0 in Key Serie A Clash",
            author: "footballgirl",
              date: "March 5, 2026",
      image: "images/seriea/5a.jpg",
        content: `<p>AS Roma secured a vital 
            1-0 victory over Inter Milan Women
             on matchday 15, with Evelyne Viens
              scoring the decisive goal to extend
               Roma's lead at the top of the table. 
               s result ended Inter's eight-match 
            winning streak and boosted Roma's title hopes.</p>`,
            tags: [ " AS Roma", "Inter Milan Women", "Evelyne Viens" ],
            navIndices: { prev: 'seriea-4', next: 'seriea-6' }
        });
    }

    init() {
        console.log('ArticlePageSERIEA5 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to Serie A
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'seriea' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_seriea.png';
            leagueLogo.alt = 'Serie A';
        }
    }
}